import { AbstractClientGoogleReCaptchaService } from "@ehealth_tools/client-google-recaptcha/src/services/clientGoogleRecaptcha.service";


export class ActivmedBookingCaptcha extends AbstractClientGoogleReCaptchaService {
    /** @override */
    protected override getGoogleReCaptchaPublicKey(): string {
        return "6LeutX0qAAAAAAWLB4u-8jaqhkRltzunAU2Ab823";
    }

}